export default {"src":"/_next/static/media/Rainbow_Rolls.d8bed23c.svg","height":78,"width":200,"blurWidth":0,"blurHeight":0};